module.exports = __webpack_public_path__ + "static/media/blue_radio_checked.a2f15402.svg";